import { Component } from '@verndale/core';

class SubNavigationBlock extends Component {
  setupDefaults() {
    this.dom = {
      links: this.el.querySelectorAll('.sub-navigation-block__link'),
      seeMore: this.el.querySelector('.sub-navigation-block__see-more')
    };

    this.maxArticles = parseInt(this.el.dataset.maxArticles, 10);
    this.showingArticles = this.maxArticles;

    this.hideArticles();
  }

  addListeners() {
    this.dom.seeMore.addEventListener('click', () => this.handleSeeMore());
  }

  hideArticles() {
    if (this.dom.links.length > this.maxArticles) {
      this.dom.links.forEach((link, index) => {
        if (index >= this.maxArticles) {
          link.classList.add('sub-navigation-block__link--hidden');
        }
      });
    } else {
      this.dom.seeMore.classList.add('sub-navigation-block__see-more--hidden');
    }
  }

  handleSeeMore() {
    let counter = 0;

    this.dom.links.forEach((link, index) => {
      if (index >= this.showingArticles && index < this.maxArticles + this.showingArticles) {
        link.classList.remove('sub-navigation-block__link--hidden');
        counter += 1;
      }
    });

    this.showingArticles += counter;

    if (this.showingArticles >= this.dom.links.length) {
      this.dom.seeMore.classList.add('sub-navigation-block__see-more--hidden');
    }
  }
}

export default SubNavigationBlock;
